import { render } from "./TheSideBar.vue?vue&type=template&id=2c5fa479&scoped=true"
import script from "./TheSideBar.vue?vue&type=script&lang=js"
export * from "./TheSideBar.vue?vue&type=script&lang=js"

import "./TheSideBar.vue?vue&type=style&index=0&id=2c5fa479&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5fa479"]])

export default __exports__